import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'
import { useRouter } from 'next/router'

import ButtonComponent from 'components/Atoms/Button'
import { BenefitCard } from 'components/Molecules'
import { Link } from 'i18n-web/i18next'
import { getAppRoute } from 'helpers/application'
import { useTranslation } from 'i18n-web/i18next'

const Component = styled.div`
  padding: 60px 0;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    padding: 80px 0;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    flex-direction: row;
    justify-content: center;
  }
`

const Button = styled(ButtonComponent)`
  padding: 0;
  width: 100%;
  height: 50px;
  color: ${props => props.theme.palette.grayDark};
  text-transform: uppercase;
  font-size: ${props => props.theme.font.size.mobile.h3};
  font-weight: 400;
  line-height: 1;
  background-color: ${props => props.theme.palette.primary};
  border: solid 4px ${props => props.theme.palette.primary};

  & + & {
    margin-top: 20px;
  }

  &:hover {
    background-color: ${props => props.theme.palette.background};
    opacity: 1;
  }

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    width: 50%;
    height: 70px;
    font-size: ${props => props.theme.font.size.desktop.h3};

    & + & {
      margin-top: 0;
      margin-left: 18px;
    }
  }
`

const CreateAccount = ({ application }) => {
  const { t } = useTranslation()
  const router = useRouter()

  return (
    <Component>
      <Grid>
        <Row>
          <Col xs={12}>
            <ButtonGroup>
              <Link
                as={`${getAppRoute(application, 'as')}/events`}
                href={`${getAppRoute(application, 'url')}/events`}>
                <Button>{t('howItWorks.createAccount.buyParking')}</Button>
              </Link>
              <Link
                as={`${getAppRoute(application, 'as')}/signup`}
                href={`${getAppRoute(application, 'url')}/signup`}>
                <Button>{t('howItWorks.createAccount.signUp')}</Button>
              </Link>
            </ButtonGroup>
            <BenefitCard
              description={t('howItWorks.createAccount.card.description')}
              image="/static/images/how-it-works/create-account/make-life-easier-safe@3x.jpg"
              label={t('howItWorks.createAccount.card.label')}
              reverse
              title={t('howItWorks.createAccount.card.title')}
              buttonText={t('howItWorks.createAccount.card.button')}
              buttonLink={() =>
                router.push(
                  `${getAppRoute(application, 'as')}/signup`,
                  `${getAppRoute(application, 'url')}/signup`
                )
              }
            />
          </Col>
        </Row>
      </Grid>
    </Component>
  )
}

CreateAccount.propTypes = {
  application: PropTypes.string,
}

export default CreateAccount
